var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "task-box", on: { click: _vm.click } }, [
      _c("div", { staticClass: "header-task" }, [
        _vm.isVideoEdit
          ? _c("img", {
              staticClass: "task-icon",
              attrs: {
                src: require("@/icons/svg/icon_task_edit.svg"),
                alt: "",
              },
            })
          : _c("img", {
              staticClass: "task-icon",
              attrs: { src: require("@/icons/svg/icon_task.svg"), alt: "" },
            }),
      ]),
      _c("div", { staticClass: "header-title" }, [_vm._v("任务中心")]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }